module.exports = __webpack_public_path__ + "static/media/tick.46d60b31.gif";